import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard/rank' // (6) 입금, 유치순위

let swrData: any = getPersistData(KEY)

export function useRank() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		amountRank: data?.find(it => it.type == 'amount')?.datas,
		countRank: data?.find(it => it.type == 'count')?.datas,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}